<template>
	<v-modal class="v-modal--welcome-form v-modal--expanded" v-bind="$attrs">
		<template v-if="refs.tabs" v-slot:header>
			<template v-if="previousTask && refs.tabs.next">
				<h1 v-if="!previousTask?.complete" class="alpha">Don't forget!</h1>
				<h1 v-else class="alpha">Making Progress!</h1>
			</template>
			<h1 v-else-if="taskToDisplay" class="alpha">Your <span v-html="step"/> Task</h1>
			<h1 v-else class="alpha">Your <span
				v-html="$present('ntext', '# Remaining Task', '# Remaining Tasks', remainingTasks().length)"/></h1>
		</template>
		<div class="section">
			<v-tabs ref="tabs" :tabless="true" :update-hash="false">
				<v-tab v-if="previousTask" id="previous-task" :mount-on-show="true" label="Previous Task">
					<div :class="buddyClass(previousTask)" class="section--buddy">
						<p v-if="!previousTask.complete" class="beta">You will still need to
							<span
								v-html="$present('lower', previousTask.descriptions.auto)"/></p>
						<OutcomeBadge
							v-else
							:result="true" class="outcome--open outcome--horizontal">
							<div slot="successMessage" class="outcome__message">
								<p class="beta">Thank you for <span
									v-html="$present('lower', previousTask.descriptions.past.auto)"/></p>
							</div>
						</OutcomeBadge>
					</div>
				</v-tab>
				<v-tab v-if="taskToDisplay" id="next-task" label="Next Task">
					<div :class="buddyClass()" class="section--buddy">
						<div class="editorial">
							<p class="beta">Your <span v-html="$present('lower', step)"/> task is to <span
								class="heavy"
								v-html="$present('lcWords', taskToDisplay.descriptions.auto)"/>.</p>
							<template v-if="taskToDisplay.key === 'payOutstandingInvoice'">
								<p>Paying your invoice speeds up your move as we cannot complete some of your key tasks until payment has been received.</p>
							</template>
						</div>
					</div>
				</v-tab>
				<v-tab
					v-for="(task, taskIndex) in remainingTasks()"
					v-if="!taskToDisplay"
					:id="task.key"
					:key="taskIndex"
					:label="task.tasks.auto"
					:on-show="() => { activateTask(task) }"
					:tab-key="taskIndex">
					<div :class="buddyClass(task)" class="section section--buddy">
						<p class="beta">You need to <span
							class="heavy"
							v-html="$present('lower', task.descriptions.auto)"/>.</p>
					</div>
				</v-tab>
			</v-tabs>
		</div>
		<template v-if="refs.tabs" v-slot:footer>
			<ul class="actions actions--right">
				<template v-if="previousTask && refs.tabs.next">
					<template v-if="!previousTask.complete">
						<li>
							<button
								class="button"
								@click.prevent="refs.tabs.goToNext()">What's Next?
							</button>
						</li>
						<li>
							<button
								class="button button--primary"
								@click.prevent="triggerTask(previousTask)">Do This Now
							</button>
						</li>
					</template>
					<template v-else>
						<li>
							<button
								class="button button--primary"
								@click.prevent="refs.tabs.goToNext()">What's Next?
							</button>
						</li>
					</template>
				</template>
				<template v-else-if="taskToDisplay">
					<li>
						<button
							class="button"
							@click.prevent="$vmodal.close()">I'll Do This Later
						</button>
					</li>
					<li>
						<button
							class="button button--primary"
							@click.prevent="triggerTask(taskToDisplay || remainingTask)">Do This Now
						</button>
					</li>
				</template>
				<template v-else-if="remainingTask">
					<li v-if="!refs.tabs.next">
						<button
							class="button"
							@click.prevent="$vmodal.close()">I'll Do This Later
						</button>
					</li>
					<li v-else>
						<button
							class="button"
							@click.prevent="refs.tabs.goToNext()">What's Next?
						</button>
					</li>
					<li>
						<button
							class="button button--primary"
							@click.prevent="triggerTask(remainingTask)">Do This Now
						</button>
					</li>
				</template>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import {mapGetters} from "vuex";
import OutcomeBadge from "../../../common/components/OutcomeBadge";
import essentialTasks from "../mixins/essentialTasks";

export default {
	components: {
		OutcomeBadge,
	},

	mixins: [
		essentialTasks,
	],

	data() {
		return {
			remainingTask: null,
		};
	},

	props: {
		previousTaskKey: {
			required: false,
			type: String,
		},
	},

	computed: {
		...mapGetters([
			"essentialTasks",
			"incompleteTasks",
			"remainingTasks",
			"nextTask",
			"nextTaskAfter",
			"task",
		]),
		previousTask() {
			return this.task(this.previousTaskKey);
		},
		taskToDisplay() {
			return this.previousTask ? this.nextTaskAfter(this.previousTaskKey) : this.nextTask();
		},
		step() {
			return this.previousTask ? "Next" : (this.incompleteTasks().length === this.essentialTasks().length ? "First" : "Next");
		},
	},

	methods: {
		activateTask(task) {
			this.remainingTask = task;
		},
		buddyClass(task = null) {
			let classes = {
				confirmPurchasePropertyAddress: "section--search-pack",
				completeIdCheck: "section--id-checks",
				completeProofOfFunds: "section--proof-of-funds",
				completeProtocolPack: "section--protocol-pack",
				default: "section--general",
			};
			let appliedClasses = {};
			let key = classes[(task || this.taskToDisplay)?.key] || classes["default"];

			appliedClasses[key] = true;

			return appliedClasses;
		},
	},
};
</script>
